var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotificationOutline = function SvgIconNotificationOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.991 2c1.422 0 2.654 1 2.975 2.354C28.438 5.686 32.5 10.618 32.5 16.5v11H34a1.5 1.5 0 0 1 0 3h-7.06C26.527 34.042 23.928 37 20 37s-6.527-2.958-6.94-6.5H6a1.5 1.5 0 0 1 0-3h1.5v-11c0-5.882 4.063-10.814 9.535-12.146C17.375 3.001 18.568 2 19.991 2m-3.906 28.5c.37 2.11 1.91 3.5 3.915 3.5s3.546-1.39 3.915-3.5zM20 7a9.5 9.5 0 0 0-9.5 9.5v11h19v-11A9.5 9.5 0 0 0 20 7",
    clipRule: "evenodd"
  })));
};
export default SvgIconNotificationOutline;